<template>
  <div
    :class="[
      'img-block',
      isEditMode && 'border',
      !selected ? 'selectionMode__not-selected' : 'selectionMode__selected'
    ]"
  >
    <img
      @click="toggleFullscreen(image, index)"
      class="img-thumbnail"
      :class="[!isEditMode && 'img-thumbnail__effect']"
      alt="thumbnail"
      :src="url"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'ShootingGalleryItem',

  data() {
    return {
      checkbox: false
    }
  },

  props: {
    image: {
      type: Object
    },
    url: {
      type: String,
      default: ''
    },
    index: {
      type: Number,
      default: 0
    }
  },

  computed: {
    ...mapState({
      isEditMode: state => state.editShooting.isEditMode,
      selectedImages: state => state.editShooting.selectedImages
    }),
    selected() {
      return this.selectedImages.indexOf(this.image) !== -1
    }
  },

  methods: {
    toggleFullscreen(image, index) {
      if (!this.isEditMode) {
        this.$emit('toggle-fullscreen', true, index)
      } else {
        if (!this.selected) {
          this.$store.commit('UPDATE_SELECTED_IMAGES', {
            type: 'push',
            value: image
          })
        } else {
          this.$store.commit('UPDATE_SELECTED_IMAGES', {
            type: 'splice',
            value: image
          })
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
.img-block {
  height: 110px;
  margin: 0 5px;
  border-radius: 5px;
  cursor: pointer;
  transition: transform 0.5s;
}

.img-thumbnail {
  width: auto;
  z-index: 10;
  height: 100%;
  padding: 5px;
  border-radius: 5px;
}

.img-thumbnail__effect {
  transition: transform 0.2s;
}

.img-thumbnail__effect:hover {
  transform: scale(1.1);
}

.border {
  border-width: 3px;
  border-style: solid;
  transition: transform 0.5s;
}

.border:hover {
  transform: scale(1.1);
}

.selectionMode__not-selected {
  border-color: gray;
}

.selectionMode__selected {
  border-color: var(--v-primary-base);
}

.absolute-display-checkbox {
  position: absolute;
  z-index: 15;
  left: 10px;
  top: 0px;
}
</style>
